import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/ChatClassification.module.css";

function formatElapsed(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

const RecordingTimer: React.FC = () => {
  const startedAtRef = useRef(Date.now());
  const [elapsedMs, setElapsedMs] = useState(0);

  useEffect(() => {
    const startedAt = startedAtRef.current;
    const interval = setInterval(() => {
      setElapsedMs(Date.now() - startedAt);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return <span className={styles.recordingTimer}>{formatElapsed(elapsedMs)}</span>;
};

export default RecordingTimer;
